import script from "./RegionCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionCoupon.vue?vue&type=script&setup=true&lang=js"

import "./RegionCoupon.vue?vue&type=style&index=0&id=316f5496&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316f5496"]])

export default __exports__